import { FormControlLabel, Checkbox } from "@mui/material";
import { OptInCheckBoxLabel } from "./opt-in-checkbox-label";
import { CheckBoxIcon, CheckedBoxIcon } from "components";

type ComponentProps = {
  isSmsOpted: boolean;
  onChange: any;
};

export const OptInCheckBox = (props: ComponentProps) => {
  // extract props
  const { isSmsOpted, onChange } = props;

  return (
    <FormControlLabel
      control={
        <Checkbox
          disableFocusRipple
          disableRipple
          icon={<CheckBoxIcon />}
          checked={isSmsOpted}
          onChange={onChange}
          checkedIcon={<CheckedBoxIcon />}
        />
      }
      label={<OptInCheckBoxLabel />}
      sx={{ marginBottom: "15px" }}
    />
  );
};
